import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import Tables from 'components/modules/trends/GroupTrend/Tables/Tables';
import React, { useEffect, useState } from 'react';
import { IPropsBlockPage } from '../../BlockPage';
import EditColumns from '../EditColumns/EditColumns';
import stylesBlock from './../../BlockPage.module.css';
import styles from './all-types-page.module.css';

function AllTypesPage(props: IPropsBlockPage) {
    const { propTree, selectData, addElement, delElement, changeSelectElement, propHeader, changeInput } = props;

    const [openEditTypes, setOpenEditTypes] = React.useState<boolean>(false);
    const [checker, setChecker] = React.useState<string[]>([]);
    const [checkedID, setCheckedID] = React.useState<string[]>([]);
    const [objIdsArr, setObjIdsArr] = React.useState<string[]>([]);
    //for Types
    const typeNamesArr: any[] = [];
    const [typeNames, setTypeNames] = React.useState<any[]>([]);
    const [dataFromServer, setDataFromServer] = React.useState<any>(null);
    const [selectedTypes, setSelectedTypes] = React.useState<any[]>([]);
    //for editColumns
    const [settingsTable, setSettingsTable] = React.useState<boolean>(false);

    const [dataTable, setDataTable] = React.useState<any[]>([]);

    const [classIndex, setClassIndex] = useState<Map<string, any[]>>(new Map());

    const [tableHeader, setTableHeader] = React.useState<any[]>(propHeader);

    const [optionFilter, setOptionFilter] = React.useState<any[]>([]);

    // Функция для создания индекса при изменении propTree
    useEffect(() => {
        const newIndex = new Map<string, any[]>();

        propTree.current.forEach((value: any) => {
            if (!newIndex.has(value.ClassName)) {
                newIndex.set(value.ClassName, []);
            }
            newIndex.get(value.ClassName)!.push(value);
        });

        setClassIndex(newIndex);
    }, [propTree]);

    // Фильтрация по selectedTypes с использованием индекса
    useEffect(() => {
        if (selectedTypes.length > 0) {
            const tempDataTable: any[] = [];

            selectedTypes.forEach((type) => {
                const values = classIndex.get(type);
                if (type === 'iXyberBaseLib.Parameter' && Array.isArray(values)) {
                    values.forEach((item) => {
                        item['sourceIn.address'] = item.sourceIn.address;
                        item['sourceOut.address'] = item.sourceOut.address;
                        item['sourceOut.location'] = item.sourceOut.location;
                        item['sourceOut.location'] = item.sourceOut.location;
                        item['sourceIn.refinterface.rpath'] = item.sourceOut.refinterface.rpath;
                        item['sourceOut.refinterface.rpath'] = item.sourceOut.refinterface.rpath;
                    });
                }

                if (values) {
                    tempDataTable.push(...values);
                }
            });

            setDataTable(tempDataTable);
        }
    }, [selectedTypes, classIndex]);

    //Поиск типов
    useEffect(() => {
        hmiclientbase.SettingsGetObjectDto('').then((data: any) => {
            hmiclientbase.SettingsGetTypesWithProperties(data.objectmodel.id).then((obj: any) => {
                setDataFromServer(obj);
                const namesWithProperties = Object.entries(obj);
                const names: string[] = [];
                namesWithProperties.map(([key, _]) => names.push(key));
                setTypeNames(names);
                setSelectedTypes(names);

                //Запись типов для фильтрации
                const filter = [
                    { action: false, param: [], selParam: [], type: 'text' },
                    { action: true, param: [], selParam: [], type: 'text' },
                    { action: true, param: [], selParam: [], type: 'text' },
                    { action: true, param: names, selParam: [], type: 'list' },
                    { action: true, param: [], selParam: [], type: 'text' },
                    { action: true, param: [], selParam: [], type: 'text' }
                ];

                setOptionFilter(filter);
            });
        });
    }, []);

    function handleSaveTypes(typesToSend: any[]) {
        setSelectedTypes(typesToSend);
        setOpenEditTypes(false);
    }

    const CheckItem = (item: any, check: boolean) => {
        let index = dataTable.findIndex((f) => f.id == item.id);
        if (index > -1) {
            let checker_t = [...checker];
            if (check && checker_t.findIndex((f) => f == dataTable[index].id) == -1)
                checker_t.push(dataTable[index].id);
            else checker_t = checker_t.filter((f) => f != dataTable[index].id);
            setChecker(checker_t);
        }
        let tempIds: string[] = checkedID;
        if (item.id.key) {
            for (let id of objIdsArr) {
                if ((item.id.key as string).includes(id)) {
                    if (check) {
                        tempIds.push(id);
                    } else {
                        tempIds = tempIds.filter((i) => !i.includes(id));
                    }
                    break;
                }
            }
        }
        setCheckedID(tempIds);
    };

    const CheckItemAll = (check: boolean, dataId: string[]) => {
        let checker_t: string[] = [];
        let checkedID: string[] = [];
        if (check) {
            checker_t = dataId;
            checkedID = objIdsArr;
        }

        setChecker(checker_t);
        setCheckedID(checkedID);
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'right', padding: '5px', height: '25px' }}>
                {/* <ButtonIcon
                    title="Выбрать тип"
                    onClick={() => setOpenEditTypes(true)}
                    src="/ixyber/vision/static/images/trends/main/Show_menu.svg"
                /> */}
                <div className={stylesBlock.iconBut}>
                    <div
                        title="Добавить/Убрать столбцы"
                        className={stylesBlock.addBlock}
                        style={{ padding: '2.5px' }}
                        onClick={() => setSettingsTable(true)}></div>
                </div>
            </div>
            <div className={styles.allTypesPageTable}>
                <Tables
                    key={'tableAllTypesPage'}
                    width="max-content"
                    height="95%"
                    isFullRender={false}
                    actionSort={true}
                    actionFilter={true}
                    optionFilter={optionFilter}
                    header={tableHeader}
                    data={dataTable}
                    checked={checker}
                    onCheck={(item, check) => {
                        CheckItem(item, check);
                    }}
                    onAllCheck={(check: boolean, dataId: string[]) => {
                        CheckItemAll(check, dataId);
                    }}
                />
            </div>
            {/* {openEditTypes && (
                <EditTypes
                    dataFromServer={dataFromServer}
                    typeNames={typeNames}
                    handleSaveTypes={handleSaveTypes}
                    onClose={() => setOpenEditTypes(false)}
                />
            )} */}
            {settingsTable && (
                <EditColumns
                    onClose={() => setSettingsTable(false)}
                    onSave={(selectedColumns) => {
                        setTableHeader(selectedColumns);
                    }}
                    selectData={selectData}
                    tableHeader={tableHeader}
                />
            )}
        </>
    );
}

export default AllTypesPage;
